// Access types that are not device types (those come from the RTDB `device_types` node
// via useDeviceTypes and get merged on top). Shared by the Access Type filter and by
// useLogType for row labels. Keys must match the stored `access_type` value because the
// filter queries `where('access_type', '==', ...)`: one-time codes are stored as `otc`.
// `visitor` and `emergency` are intentionally absent: useLogType labels those from
// `role` / `guard_access`, and they are not filterable access types.
export const STATIC_ACCESS_TYPES = {
    kiosk: 'Call',
    operator: 'Operator',
    scan: 'Access Key',
    lpr: 'LPR',
    ca4k: 'CA4K',
    otc: 'Code',
    pass: 'Pass'
};
